import {
  registerDecorator,
  type ValidationOptions,
  type ValidationArguments,
} from 'class-validator';

/**
 * Validates that a value is a TRBL (Top, Right, Bottom, Left) coordinate array.
 * Must be an array of exactly 4 non-negative numbers.
 * Used to validate padding, margin, and border radius props.
 */
export function IsTRBLNumberCoords(validationOptions?: ValidationOptions) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      name: 'isTRBLNumberCoords',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(value: unknown) {
          if (!Array.isArray(value)) {
            return false;
          }
          if (value.length !== 4) {
            return false;
          }
          return value.every((v) => typeof v === 'number' && Number.isFinite(v) && v >= 0);
        },
        defaultMessage(args: ValidationArguments) {
          return `${args.property} must be an array of 4 non-negative numbers [top, right, bottom, left]`;
        },
      },
    });
  };
}
